const fr = {
  common: {
    dailyLimit: "Limite quotidienne atteinte. Revenez demain.",
    loading: "Chargement...",
    serverError: "Erreur serveur",
  },
  intro: { playNow: "Jouer", knowMore: "En savoir plus" },
  login: {
    fillFields: "Veuillez remplir tous les champs !",
    invalid: "Numéro invalide",
    title: "Connexion pour commencer le jeu",
    number: "Entrez le numéro",
    numberLabel: "Entrez le numéro de mobile",
    numberPlaceholder: "Numéro de mobile",
    password: "Entrez le mot de passe",
    login: "Connexion",
    subscribeLink: "Pas encore utilisateur ? Abonnez-vous",
    lowbalance:
      "Solde insuffisant. Rechargez votre crédit et réessayez pour accéder au service.",
    inprocess: "La facturation du service est en cours. Veuillez patienter.",
    invalidNumber: "Entrez un numéro de téléphone valide.",
    errorMsg: "Une erreur s’est produite !",
    notSub: "Aucun abonnement trouvé",
  },
  register: {
    fillFields: "Veuillez remplir tous les champs !",
    title: "Abonnez-vous pour commencer",
    name: "Entrez le nom",
    number: "Entrez le numéro",
    numberLabel: "Entrez le numéro de mobile",
    numberPlaceholder: "Numéro de mobile",
    password: "Entrez le mot de passe",
    subscribe: "S'abonner",
    loginLink: "Déjà un utilisateur ? Connexion",
    dailyPass: "Pass quotidien",
    dailyDesc: "24 heures de jeux",
    weeklyPass: "Pass hebdomadaire",
    weeklyDesc: "7 jours d’accès",
    monthlyPass: "Pass mensuel",
    monthlyDesc: "30 jours de jeux",
    privacy: "Complément de confidentialité",
    acceptPrivacy: "Veuillez accepter le complément de confidentialité",
    paymentNote: "Paiement via le solde principal ou M-Pesa",
    lowbalance:
      "Solde insuffisant. Rechargez votre crédit et réessayez pour accéder au service.",
    inprocess: "La facturation du service est en cours. Veuillez patienter.",
    redirect: "Veuillez patienter, vous allez être redirigé pour confirmer votre abonnement",
    subSuccess:
      "Vous recevrez un message de confirmation d’abonnement. Veuillez le confirmer. Après confirmation, cliquez sur le bouton ci-dessous.",
    invalidNumber: "Entrez un numéro de téléphone valide.",
    alreadySub:
      "Vous êtes déjà abonné. Pour accéder au service, cliquez sur le bouton « Cliquez ici » ci-dessous",
    errorMsg: "Une erreur s’est produite !",
    clickHere: "Cliquez ici",
    notSub: "Aucun abonnement trouvé",
  },
  home: { title: "Niveaux de jeu" },
  account: {
    account_subtitle: "Joueur du jeu de cartes cachées",
    pointText: "Points totaux",
    currentlevel: "Niveau actuel",
    gameprogress: "Progression du jeu",
    levelprogress: "Progression du niveau",
    btn: "Se désabonner",
    unsubTitle: "Confirmer le désabonnement",
    unsubText:
      "Êtes-vous sûr de vouloir vous désabonner de votre forfait actuel ? Vous pourriez perdre l’accès aux jeux premium et aux avantages actifs.",
    unsubCancel: "NON",
    unsubConfirm: "OUI",
    errorMsg: "Une erreur s’est produite !",
    nameUpdated: "Nom mis à jour avec succès !",
    editProfile: "Modifier le profil",
    save: "Enregistrer",
    cancel: "Annuler",
    wheelSpin: "Roue",
    locked: "Verrouillé",
    completeLevel10: "Terminez le niveau 10",
    alreadySpin: "Vous avez déjà tourné aujourd'hui",
    goHome: "Aller à l'accueil",
    userHistory: "Historique",
  },
  level: {
    level: "Niveau",
    subtitle: "Trouvez le bon objet !",
    tapPuzzle: "Appuyez pour ouvrir l’énigme",
    puzzleTitle: "Énigme",
    chooseObj: "Choisissez le bon objet",
    gameOver: "Jeu terminé",
    usedTries: "Vous avez utilisé toutes les tentatives",
    restart: "Redémarrer",
    home: "Accueil",
    wrong: "Faux ! Réessayez",
    correct: "Correct",
    loading: "Chargement...",
    silverUnlocked: "Chit argent débloqué !",
    goldenUnlocked: "Chit or débloqué !",
    diamondUnlocked: "Chit diamant débloqué !",
    exploreNow: "Explorer",
    claimReward: "Récupérer la récompense",
    timeLeft: "Temps restant",
  },
  history: {
    levelHistory: "Historique des niveaux",
    spinHistory: "Historique de la roue",
    goldenTitle: "Récompense chit or",
    diamondTitle: "Récompense chit diamant",
    noHistory: "Aucun historique",
    level: "Niveau",
    points: "Points",
    date: "Date",
    riddle: "Énigme",
    answer: "Réponse",
    spin: "Tour",
    goldenReward: "Récompense chit or",
    reward: "Récompense",
    goldenRewardLabel: "Récompense d'or",
    type: "Type",
    diamond: "Diamant",
    noDiamond: "Aucune récompense diamant",
  },
  silver: {
    wonPrize: "Prix gagné",
    clickOpen: "Cliquez pour ouvrir",
    opening: "Ouverture...",
    spinning: "Ça tourne...",
    spinWheel: "Tourner la roue",
    youWon: "Vous avez gagné",
    nextLevel: "Niveau suivant",
  },
  golden: { congrats: "Félicitations !", claimPrize: "Récupérer le prix" },
  diamond: {
    title: "Archive diamant",
    claimAll: "Récupérer toutes les récompenses",
    hint: "Cliquez sur l'enveloppe diamant pour ouvrir !",
    data: "Data",
    points: "Points",
  },
  finish: {
    gameOver: "FIN DU JEU",
    clickEnvelopes: "Cliquez sur les enveloppes pour révéler les récompenses",
    screenshotTip: "Faites une capture et partagez votre victoire !",
    allCollected: "TOUT COLLECTÉ !",
    finalText:
      "Vous avez collecté tous les trésors. Consultez votre compte pour le solde !",
    goAccount: "ALLER AU COMPTE",
    toolLoading: "Outil encore en chargement...",
    victory: "Victoire !",
    shareText: "J'ai gagné au Hidden Chit Game !",
  },
  levelMap: {
    subHeader: "Terminez les 50 niveaux et débloquez les récompenses !",
    silver: "Chit argent",
    golden: "Chit or",
    diamond: "Chit diamant",
    trophy: "Trophée",
  },
};

export default fr;
